// This file can be replaced during build-mobile by using the `fileReplacements` array.
// `ng build-mobile --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  api: 'https://tolpucon-qa-5ea8eba4502b.herokuapp.com',
  //api: 'http://localhost:3000',
  folderFirebasePhotoUsuarios: 'usuarios/foto_perfil/',
  folderFirebaseDocumentos: 'documentos/obra/',
  folderFirebaseDeclaraciones: 'declaracion_en_primera_instancia/',

  imagenDefectoUsuario : 'https://firebasestorage.googleapis.com/v0/b/tolpucon-prod-1a510.appspot.com/o/tolicon.png?alt=media&token=fe180390-740e-43ea-9be0-2de3811dffb9',
  encryptSecret: 'agdahfkalfaslhopjksotgashg.dasdqgtadadlq4123123123.1e$',
  production: false
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
